export default __webpack_public_path__ + "static/media/umptkin.1d3a697f.png";